export const CLIENT_RUNTIME_CONFIG_KEYS = [
  'REACT_APP_API_URL',
  'REACT_APP_IMAGES_S3_PRODUCTS_BUCKET',
  'REACT_APP_IMAGES_S3_ACCOUNTS_BUCKET',
  'REACT_APP_SESSION_TIMEOUT',
  'REACT_APP_SESSION_PROMPT_TIMEOUT',
  'REACT_APP_SHOP_APP_URL',
  'REACT_APP_GEMS_PRODUCT_ID',
  'REACT_APP_GA_MEASUREMENT_ID'
];
